import ErrorIconMessage from './ErrorIconMessage';

export default ErrorIconMessage;
